import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.DisableSyncMenuItem', {
    disableBudgetSyncWith: 'Disable budget sync with {integrationName}',
});
